import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Center,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Spinner,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import API from "../../api";
import OverviewFilter from "../../components/overviewFilter";
import { useAppContext } from "../../context/index";
import logger from "../../utils/logger";

const Payouts = () => {
  const [loading, setLoading] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const toast = useToast();
  const { partner, setPartner, fetchPartner } = useAppContext();
  const [tableData, setTableData] = useState([]);
  const [partnerData, setPartnerData] = useState([]);
  const [invoiceAmount, setInvoiceAmount] = useState(0);

  const fetchPayoutsData = async ({
    from = new Date(new Date(Date.now()).setHours(0, 0, 0, 0)),
    to = new Date(new Date(Date.now()).setHours(23, 59, 59, 999)),
    appEnabled = false,
    partnerEnabled = false,
  }) => {
    try {
      console.log("get data", from, to, appEnabled, partnerEnabled);
      setLoading(true);

      await API(
        "/analytics/get-payouts?" +
          new URLSearchParams({
            from,
            to,
            appEnabled,
            partnerEnabled,
          }),
        "GET"
      )
        .then((data) => {
          if (data) {
            console.log(data);
            setTableData(data?.payouts);
            setPartnerData(data);
          }
        })
        .catch((err) => {
          toast({
            title: "Error in fetching data!",
            description: err?.error ?? "Internal Server Error!",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
          console.log("error", err);
        });
      setLoading(false);
    } catch (error) {
      logger({
        functionName: "OverView Anlytics Data.initializeAnalyticsData",
        error,
        sentry: true,
      });
      setLoading(false);
    }
  };

  const handlePayoutModal = () => {
    onOpen();
  };

  const createPayoutApi = async () => {
    try {
      setLoading(true);
      await API("/analytics/create-payout", "POST", { amount: invoiceAmount })
        .then((data) => {
          if (data) {
            console.log(data);
          }
        })
        .catch((err) => {
          toast({
            title: "Error in fetching data!",
            description: err?.error ?? "Internal Server Error!",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
          console.log("error", err);
        });
      onClose();
      fetchPayoutsData({});
      setLoading(false);
    } catch (error) {
      logger({
        functionName: "Payouts Data.createPayoutApi",
        error,
        sentry: true,
      });
      onClose();
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayoutsData({});
  }, []);

  const onApply = async (data) => {
    await fetchPayoutsData({ ...data });
  };

  return (
    <>
      {" "}
      <div
        className="form-box"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
          margin: "20px -20px",
        }}
      >
        <OverviewFilter onApply={onApply} payout={handlePayoutModal} />
      </div>
      <div
        className="form-box"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
          margin: "20px -20px",
        }}
      >
        <SimpleGrid
          spacing={4}
          templateColumns="repeat(auto-fill, minmax(200px, 1fr))"
        >
          <Card>
            <CardHeader>
              <Heading size="md">Total Paid Amount</Heading>
            </CardHeader>
            <CardBody>
              <Text>Amount : ₹ {partnerData?.totalPayedAmount}</Text>
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <Heading size="md">Total Withdrawable Amount</Heading>
            </CardHeader>
            <CardBody>
              <Text>
                Amount : ₹{" "}
                {partnerData?.totalEarned - partnerData?.totalPayedAmount}
              </Text>
            </CardBody>
          </Card>
        </SimpleGrid>
      </div>
      <div
        className="form-box"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
          margin: "0px -20px",
        }}
      >
        {" "}
        {loading ? (
          <Center bg="white" h="100px">
            <Spinner />
          </Center>
        ) : (
          <Box>
            <TableContainer>
              <Table variant="striped" colorScheme="gray">
                <TableCaption>
                  Please Go to Settings to Generate the token and integrate it
                  on Codfirm to see your earned commision.
                </TableCaption>
                <Thead>
                  <Tr>
                    <Th>S No.</Th>
                    <Th>Amount</Th>
                    <Th>Payment Status</Th>
                    <Th>Created At</Th>
                    <Th>Payment CompletedAt At</Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {tableData?.length > 0 ? (
                    tableData.map((row, index) => {
                      return (
                        <Tr key={index}>
                          <Td>{index + 1}</Td>
                          <Td>{row?.amount}</Td>
                          <Td>
                            {row?.status === "pending"
                              ? "Pending"
                              : "Completed"}
                          </Td>
                          <Td>
                            {row?.createdAt
                              ? new Date(row?.createdAt).toDateString()
                              : ""}
                          </Td>
                          <Td>
                            {row?.paymentCompletedAt
                              ? new Date(row?.paymentCompletedAt).toDateString()
                              : ""}
                          </Td>
                        </Tr>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
            <Modal isOpen={isOpen} onClose={onClose}>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Create Invoice</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <FormControl
                    id="amount"
                    isRequired
                    // isInvalid={errors?.amount ? true : false}
                  >
                    <FormLabel>Input Amount</FormLabel>
                    <Input
                      type="number"
                      name="amount"
                      onChange={(e) => setInvoiceAmount(e.target.value)}
                      value={invoiceAmount}
                    />
                    <FormHelperText>
                      Amount should be less then or equal to withdrawable
                      amount.
                    </FormHelperText>
                    {/* {<FormErrorMessage>{errors?.email}</FormErrorMessage>} */}
                  </FormControl>
                </ModalBody>

                <ModalFooter>
                  <Button
                    colorScheme="green"
                    mr={3}
                    onClick={createPayoutApi}
                    isDisabled={invoiceAmount ? false : true}
                  >
                    Submit
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </Box>
        )}
      </div>
    </>
  );
};

export default Payouts;
